export default {
  form: {
    step1: {
      strategicLesson: "Strategic Lesson",
    },
    step3: {
      help: {
        closeButton: "Close",
        apiField: "API field",
        usedInRoutes: "Used in routes",
        usedInComponents: "Used in components",
        responsiveness: "Responsiveness",
        fallback: "Fallback",
        additionalNotes: "Notes",
        notUsedWarning:
          "This cover is not currently used in the frontend application.",
      },
    },
  },
};
